import { CsI18n } from './csI18n';
export default CsI18n;